module.exports = "/shared/fonts/proxima-nova-black.otf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/proxima-nova-black.otf
// module id = 16
// module chunks = 13